import Web3 from 'web3'
import {Contracts} from './lib/contracts.js'
import {EVM} from './lib/evm.js'

// import {contractAddresses} from  './lib/constants'

export class Sushi {
    public web3: Web3;
    public testing: EVM;
    public snapshot: any;
    public contracts: Contracts;

    constructor(provider: any, networkId: number, testing: any, options: any) {
        let realProvider;

        if (typeof provider === 'string') {
            if (provider.includes('wss')) {
                realProvider = new Web3.providers.WebsocketProvider(
                    provider,
                    options.ethereumNodeTimeout || 10000,
                )
            } else {
                realProvider = new Web3.providers.HttpProvider(
                    provider,
                    options.ethereumNodeTimeout || 10000,
                )
            }
        } else {
            realProvider = provider
        }

        this.web3 = new Web3(realProvider);

        if (testing) {
            this.testing = new EVM(realProvider);
            this.snapshot = this.testing.snapshot()
        }
        if (options.defaultAccount) {
            this.web3.eth.defaultAccount = options.defaultAccount
        }
        this.contracts = new Contracts(realProvider, networkId, this.web3, options);

    }


    // setProvider(provider, networkId) {
    //     this.web3.setProvider(provider);
    //     this.contracts.setProvider(provider, networkId);
    //     this.operation.setNetworkId(networkId)
    // }


}
